import { useImperativeHandle, forwardRef } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";

// eslint-disable-next-line no-empty-pattern
const M11Step038GatherAppendices = forwardRef(({ }, ref) => {

    const m11User = useSelector(selectCurrentUserM11Use);

    return <div>
        <h3>Gather Appendices</h3>
        <p>Gather appendices for any additional details to be added to sections 12 to 14.</p>
        <p>Appendices will include:</p>
        <div style={{ marginLeft: "24px" }} >
            <p>a list of abbreviations and definitions used (section 13)</p>
            <p>a list of references cited (section 14)</p>
            <p>a list of clinical laboratory tests included in each assessment panel (section 12.1)</p>
            <p>any protocol differences by country or region (section 12.2)</p>
            <p>any prior protocol amendments (section 12.3)</p>
            <p>ny other additional appendices (section 12.4, 12.5, etc.)</p>
        </div>
        {m11User === "sample" &&
            <div>
                <p>You are using the M11 Report Authoring Tool (Test Drive Version). You only need to gather a list of references cited.  Go to Step 42 (Complete Section 14 References) next.</p>
            </div>
        }
    </div >
});

const M11Step038GatherAppendicesHelperText = <div>
    <h3>Gather Appendices</h3>
    <div style={{ textAlign: "left" }}>
        <p>Gather appendices for any additional details to be added to sections 12 to 14.</p>
        <p>Appendices will include:</p>
        <div style={{ marginLeft: "24px" }} >
            <p>a list of abbreviations and definitions used (section 13)</p>
            <p>a list of references cited (section 14)</p>
            <p>a list of clinical laboratory tests included in each assessment panel (section 12.1)</p>
            <p>any protocol differences by country or region (section 12.2)</p>
            <p>any prior protocol amendments (section 12.3)</p>
            <p>ny other additional appendices (section 12.4, 12.5, etc.)</p>
        </div>
        <p>There is no data to save in this step.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step038GatherAppendicesValidationCheck = ({ }) => {
    return <div>
        <h4>Step 38 (Gather Appendices) has no validation check.</h4>
          </div>
}

export default M11Step038GatherAppendices;
export { M11Step038GatherAppendicesHelperText, M11Step038GatherAppendicesValidationCheck};